import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth";

import Divider from "../layout/Divider.js";
import Space from "../layout/Space";

import PrimaryButton from "../buttons/PrimaryButton";
import { useSnackbar } from "notistack";
import SmallSpinner from "../loading/SmallSpinner.js";
import { useAppContext } from "../config/AppContext.js";
import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";
import Modal1 from "../modals/Modal1.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import SecondaryButton from "../buttons/SecondaryButton";

import Icon1 from "../icons/Icon.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import type { User as FirebaseUser } from "firebase/auth";

import createDocApi from "../api/database/createDocApi.js";

import TextField2T from "../textfields/TextField2T";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import Gleap from "gleap";
import { ToggleSettingsBrick } from "../textfields/EasySwitch.js";
import createNewPartner from "../api/create/createNewPartner.js";
import { Spin } from "antd";
import { checkPageAccessV2 } from "../auth/checkPageAccess.js";
import { getOrgById } from "../models/OrgFunctions.js";
import { User } from "../types/user";
import { Org, Workspace } from "../types/org";

type NewPartnerProps = {
  userData: User; // Replace 'any' with the correct type if available
  orgData: Org; // Replace 'any' with the correct type if available
  navigateWorkspace: (path: string) => void;
  workspaceData: Workspace | null; // Replace 'any' with the correct type if available
};

function NewPartner({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
}: NewPartnerProps) {
  const { currentUser, loading } = useAuth() as {
    currentUser: FirebaseUser | null;
    loading: boolean;
  }; // add types
  const [partner_exists, setParnterExists] = useState<any>(false);
  const [partner_open, setPartnerOpen] = useState(false);
  const type_options = [
    { value: "constructor", label: "Constructeur" },
    { value: "promotor", label: "Promoteur" },
    {
      label: "Artisans",
      id: "artisan",
    },
    { value: "architect", label: "Architecte" },
    { value: "mdo", label: "Maître d'oeuvre" },
    { value: "drawer", label: "Dessinateur" },
    { value: "expert", label: "Bureau d'étude" },
    { value: "infiltro", label: "Infiltromètre" },
    { value: "other", label: "Autre" },
  ];

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };
  const handleCheckEmailExists = async (email: any) => {
    setPartnerOpen(false);
    setParnterExists(null);

    if (email.length < 5) {
      return;
    }
    if (!email.includes("@") || !email.includes(".")) {
      setPartnerOpen(false);
      setParnterExists(null);
      return;
    }
    const filters = [
      {
        field: "email",
        operator: "==",
        value: email,
      },
    ];
    const existingUsers = ((await queryCollection("user", filters)) ||
      []) as User[];
    if (existingUsers.length > 0) {
      let org = await getOrgById(existingUsers[0].org_id);
      setParnterExists(org);
      setPartnerOpen(true);
    }
  };

  // State variables to store the input values
  const [clientType, setClientType] = useState(null);
  const [clientType_2, setClientType2] = useState(null);
  const [entreprise, setEntreprise] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [ville, setVille] = useState("");
  const [postal, setPostal] = useState("");
  const [adresse, setAdresse] = useState("");
  const [payment_allowed, setPaymentAllowed] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [partner_type, setPartnerType] = useState(null);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (currentUser) {
      try {
        // Fetch user data
        // Fetch organization data using user's org reference
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  function checkEmail(email: any) {
    if (email.length < 5) {
      return false;
    }
    if (email.indexOf("@") === -1) {
      return false;
    }
    if (email.indexOf(".") === -1) {
      return false;
    }
    return true;
  }

  const [new_partner_user_id, setNew_partner_id] = useState("");
  const [invite_open, setInviteOpen] = useState(false);
  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  const handlesendInvite = async () => {
    let new_user = (await getDocDataById("user", new_partner_user_id)) as User;
    let org = (await getOrgById(new_user.org_id)) as Org;
    if (org.invite !== "accepted") {
      await updateDocDataFieldApi(org.ref, "invite", "sent", prefix);
    }
    // await sendInvite(
    //   new_partner_user_id,
    //   orgData.name,
    //   new_user.email,
    //   org.id,
    //   token,
    //   prefix
    // ); // Call the sendInvite API
    handleClickVariant("Invitation envoyée avec succès", "success");
    navigateWorkspace("/partner/" + org.id);
  };

  // Function to create a new client
  const createPartner = async () => {
    if (!userData || !orgData) return;

    try {
      if (email === "") {
        handleClickVariant("Veuillez saisir l'adresse email", "error");
        return;
      }
      if (!checkEmail(email)) {
        handleClickVariant("Veuillez saisir une adresse email valide", "error");
        return;
      }

      const filters = [
        {
          field: "email",
          operator: "==",
          value: email,
        },
      ];

      const doublons =
        ((await queryCollection("user", filters)) as User[]) || [];
      if (doublons.length > 0) {
        const my_network_filters = [
          {
            field: "email",
            operator: "==",
            value: email,
          },
          {
            field: "masters",
            operator: "array-contains",
            value: orgData.id,
          },
        ];

        const doublons_in_network =
          (await queryCollection("org", my_network_filters)) || [];
        if (doublons_in_network.length > 0) {
          handleClickVariant(
            "Un utilisateur avec cet email existe déjà dans votre réseau",
            "error"
          );
          return;
        } else {
          // add already existing client to the network
          let partner = (await getOrgById(doublons[0].org_id)) as Org;

          let masters_id = partner.masters_id || [];
          masters_id.push(orgData.id);
          await updateDocDataFieldApi(
            partner.ref,
            "masters_id",
            masters_id,
            prefix
          );

          let workspace_body = {
            master_id: orgData.id,
            master_name: orgData.name,
            partner_id: partner.ref,
            accesses: {},
            affiliated_partners_id: [],
            commercial_infos: {},
            permissions: {
              admin_folders: false,
              new_estimates:
                orgData.partner_type != "expert" &&
                orgData.partner_type != "infiltro",
              new_folders:
                orgData.partner_type != "expert" &&
                orgData.partner_type != "infiltro",
              payment_allowed: ![
                "expert",
                "infiltro",
                "promotor",
                "constructor",
                "other",
              ].includes(orgData.partner_type),
            },
          };
          let new_workspace = (await createDocApi(
            "workspace",
            workspace_body,
            prefix
          )) as any;

          let workspaces_id = partner.workspaces_id || [];
          workspaces_id.push(new_workspace.id);

          await updateDocDataFieldApi(
            partner.ref,
            "workspaces_id",
            workspaces_id,
            prefix
          );

          handleClickVariant(
            "Un utilisateur avec cet email existe déjà dans la base de données. Il a été ajouté à votre réseau",
            "success"
          );
          Gleap.trackEvent("Client created", {
            userId: userData.id,
          });
          navigateWorkspace("/partner/" + partner.id);
        }

        return;
      }
      if (!partner_type) {
        handleClickVariant("Veuillez sélectionner la catégorie", "error");
        return;
      }

      if (entreprise === "") {
        handleClickVariant("Veuillez saisir le nom de l'entreprise", "error");
        return;
      }
      if (prenom === "") {
        handleClickVariant("Veuillez saisir le prénom", "error");
        return;
      }
      if (phone === "") {
        handleClickVariant("Veuillez saisir le numéro de téléphone", "error");
        return;
      }
      if (ville === "") {
        handleClickVariant("Veuillez saisir la ville", "error");
        return;
      }
      if (postal === "") {
        handleClickVariant("Veuillez saisir le code postal", "error");
        return;
      }

      setLoadingData(true); // Set loading state to true
      const oid = orgData.id; // Assuming orgData has the organization id

      // Get the user's Firebase authentication token
      if (!currentUser) {
        handleClickVariant("Utilisateur non authentifié", "error");
        setLoadingData(false);
        return;
      }
      const token = await currentUser.getIdToken(); // Fetch token from Firebase
      const new_user_id = await createNewPartner(
        phone.trim(), // Phone number
        email.trim(), // Email address
        ville.trim(), // City
        postal.trim(), // Postal code

        entreprise.trim(), // Company name
        partner_type, // Client type
        payment_allowed,
        adresse.trim(), // Address
        oid, // Organization ID
        token, // Firebase Authentication token
        prenom,
        prefix
      );

      let new_user = (await getDocDataById("user", new_user_id)) as User;
      await getOrgById(new_user.org_id);

      setLoadingData(false); // Set loading state to false
      setInviteOpen(true); // Close the dialog

      setNew_partner_id(new_user.id);
      handleClickVariant("Partenaire créé avec succès", "success");
    } catch (error) {
      console.error("Error creating partner:", error);
    }
  };

  if (loading || !currentUser || !userData) {
    return (
      <div className="h-full w-c400 pl-4 flex flex-col gap-2">
        <SmallSpinner />
      </div>
    );
  }

  return (
    <div className="flex-row w-full h-full overflow-auto flex gap-10 pb-20">
      <Modal1
        isOpen={invite_open}
        onClose={() => {
          setInviteOpen(false);
          navigateWorkspace("/partners");
        }}
      >
        {" "}
        <div className="bg-white flex flex-col p-4 w-c300 rounded-3xl  ">
          <div className="flex flex-col gap-3 w-full">
            <div className="flex flex-row justify-between">
              {" "}
              <div className="text-h3 text-shadow_50">
                Envoyer une invitation au client par email pour se connecter sur
                son espace
              </div>
            </div>
            <div className="flex flex-row gap-2 justify-between">
              <SecondaryButton
                className="w-full"
                onClick={() => {
                  setInviteOpen(false);
                  navigateWorkspace("/partner/" + new_partner_user_id);
                }}
              >
                Annuler
              </SecondaryButton>{" "}
              <PrimaryButton className="w-full" onClick={handlesendInvite}>
                Envoyer
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
      <Modal1
        isOpen={partner_open}
        onClose={() => {
          setPartnerOpen(false);
        }}
      >
        {" "}
        <div className="bg-white flex flex-col p-4 w-c500 rounded-3xl  ">
          <div className="flex flex-col gap-3 w-full">
            <div className="flex flex-col ">
              {" "}
              <div className="text-h3 text-black">
                Cette entreprise existe déjà dans notre base de données
              </div>
              <div className="flex flex-row gap-4 my-4  rounded-lg p-2 bg-neutral-50 border-1 border-shadow_25">
                <div className="text-h3 text-shadow_50">
                  <img
                    src={partner_exists?.logo}
                    className="w-16 h-16 rounded-lg object-contain"
                  ></img>
                </div>{" "}
                <div className="flex flex-col">
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.name}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.email}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.ville}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.postal}
                  </div>{" "}
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.phone}
                  </div>{" "}
                </div>
              </div>
              <div className="text-h3 text-shadow_50">
                Si l'entreprise correspond au partenaire que vous souhaitez
                ajouter, ajoutez le dirctement à votre réseau.
              </div>
            </div>
            <div className="flex flex-row gap-2 justify-end">
              <PrimaryButton onClick={createPartner} disabled={loadingData}>
                <div className="flex flex-row content-center align-middle items-center">
                  Ajouter le partenaire <Space x={5} />
                  <SmallSpinner loading={loadingData} margin={0} size={20} />
                </div>
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
      {/* Left Column: Takes all available space */}
      {/* Right Column: Fixed width */}
      <div className="h-fit flex  flex-col max-w-c500 pl-4 pb-20">
        <div className="text-h1 font-semibold">Nouveau partenaire</div>
        <div className="text-h3 text-shadow_50 mt-2">
          Cette interface permet d'ajouter des partenaires qui pourront
          collaborer avec vous sur les carnets d'information du logement
        </div>{" "}
        <div className={"flex flex-col h-fit gap-2  pr-2 mt-4"}>
          <TextField2T
            label="Email"
            value={email}
            type="email"
            mandatory={true}
            onChange={(e) => {
              setEmail(e.target.value);
              handleCheckEmailExists(e.target.value);
            }}
          ></TextField2T>
          <div className={"flex flex-row gap-2 h-fit w-full pr-2"}>
            <DropDownGPT03
              items={type_options as any}
              className="w-full"
              label="Catégorie"
              value={partner_type as any} // Controlled component
              mandatory={true}
              onChange={(e) => setPartnerType(e.value as any)} // Update state on change
            ></DropDownGPT03>{" "}
          </div>

          <TextField2T
            className="w-full"
            label="Entreprise"
            value={entreprise}
            mandatory={true}
            onChange={(e) => setEntreprise(e.target.value)}
          ></TextField2T>
          <TextField2T
            className="w-full"
            label="Prénom Nom"
            value={prenom}
            onChange={(e) => setPrenom(e.target.value)}
            mandatory={true}
          ></TextField2T>

          <TextField2T
            label="Téléphone"
            value={phone}
            type="phone"
            mandatory={true}
            onChange={(e) => setPhone(e.target.value)}
          ></TextField2T>
          <TextField2T
            label="Ville"
            value={ville}
            mandatory={true}
            onChange={(e) => setVille(e.target.value)}
          ></TextField2T>
          <TextField2T
            label="Postal"
            value={postal}
            mandatory={true}
            onChange={(e) => setPostal(e.target.value)}
          ></TextField2T>
          <TextField2T
            label="Adresse"
            value={adresse}
            mandatory={true}
            onChange={(e) => setAdresse(e.target.value)}
          ></TextField2T>
        </div>
        <Space y={20} />
        <div className="w-full flex flex-row justify-end">
          <PrimaryButton onClick={createPartner} disabled={loadingData}>
            <div className="flex flex-row content-center align-middle items-center">
              Créer le partenaire
              <SmallSpinner loading={loadingData} margin={5} size={20} />
            </div>
          </PrimaryButton>
        </div>
      </div>
      <div className="flex flex-col w-c400">
        <Space y={30} />
      </div>
    </div>
  );
}

export default NewPartner;
